import { render, staticRenderFns } from "./app-manage.vue?vue&type=template&id=5ea78892&scoped=true";
import script from "./app-manage.vue?vue&type=script&lang=js";
export * from "./app-manage.vue?vue&type=script&lang=js";
import style0 from "./app-manage.vue?vue&type=style&index=0&id=5ea78892&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5ea78892", null);
export default component.exports;